(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig ($stateProvider, $stickyStateProvider, $urlRouterProvider ) {
        $stateProvider.state('docs', {
            // parent: 'admin',
            parent: 'app',
            url: '/docs',
            sticky: true,
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                // 'content@': {
                'admin-docs@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });

        $stickyStateProvider.enableDebug( true );
    }
})();
